export function getDisplayLocale(language: string | undefined): string {
  const normalized = language?.toLowerCase() ?? "";
  if (normalized.startsWith("mk")) return "mk-MK";
  if (normalized.startsWith("sr")) return "sr-RS";
  return "en-GB";
}

/**
 * Locale-aware numeric date without changing the stored value or timezone.
 * Date-only ISO values are parsed in UTC so they cannot shift a day.
 */
export function formatLocalizedDate(
  value: string | Date | null | undefined,
  language: string | undefined,
): string {
  if (!value) return "";

  const raw = value instanceof Date ? null : String(value);
  const dateOnly = raw?.match(/^(\d{4})-(\d{2})-(\d{2})(?:$|T00:00:00(?:\.000)?Z$)/);
  const date = dateOnly
    ? new Date(Date.UTC(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3])))
    : value instanceof Date
      ? value
      : new Date(value);

  if (Number.isNaN(date.getTime())) return raw ?? "";

  const locale = getDisplayLocale(language);
  const formatter = new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    ...(dateOnly ? { timeZone: "UTC" } : {}),
  });

  // Macedonian Intl data appends the grammatical year marker ("г."). Product
  // date fields use the compact administrative form dd.MM.yyyy.
  if (locale === "mk-MK") {
    const parts = formatter.formatToParts(date);
    const part = (type: Intl.DateTimeFormatPartTypes) => parts.find((item) => item.type === type)?.value ?? "";
    return `${part("day")}.${part("month")}.${part("year")}`;
  }

  return formatter.format(date);
}
